<template>
    <div class="i-notify">
        <div class="notify" v-for="(notify,idx) in notificationScope" :key="`notify-${notify.id}`" :ss='notify.id' v-show-delay="!notify.hide">
            <div class="container">
                <div class="close-button" @click="hide(idx)">
                    <div class="fal fa-times"></div>
                </div>
                <div class="icon">
                    <span class="fal fa-times-circle" v-if='notify.type == "error"' style='color:#ff9e9e'></span>
                    <span class="fal fa-exclamation-triangle" v-if='notify.type == "warn"' style='color:#ffdfa5'></span>
                    <span class="fal fa-check-circle" v-if='notify.type == "success"' style='color:#95ffa2'></span>
                    <span class="fal fa-info-circle" v-if='notify.type == "info" || !notify.type' style='color:#95f0ff'></span>
                </div>
                <div class="content">
                    <div class="title">{{notify.title}}</div>
                    <div class="text">{{notify.text}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";


let audioNotify = document.createElement("audio");
let audioError = document.createElement("audio");
let audioSuccess = document.createElement("audio");
audioNotify.volume = 0.05;
audioError.volume = 0.05;
audioSuccess.volume = 0.05;
audioError.src = "data:audio/mp3;base64,//sQxAAAAAABpBQAAAE/SCPHKVABBIA8IWgHgoeBJwB7g2twOXfAC17sBoknhQL93kXAxeFRJv88Xy+b/+aIIF9P/90Guh//oU3QQ///91v///////////////////////////yyQWH/+xLEAYABGkGAGHAACSzIK8Mo0AEbWPB/1LwNO3BQKHEjLJijALBAELgteJkZ0yBYEGIRzhipDhE5J5KGJdUBRiWjxTk///////////////////////////////////////////4CAAD/+xDEAYAE0DdZPZWACJqHqgGtPJk/8AhhN8A+BnWmmoy2UuKZQhtzkJCofoG6quZgc/zwBAex6bMwKKQodIbx6nbyY6PBzBQDIGAMps0b0E8AsFMlYtflQBaFcjXKbYACSSAAwzApWf/7EsQEAASkOVZs4eTIlocrKZw8meicX0pz2JITQcIxdPB28woDSL6SFnt/k/jKPFCcAYAABttgASJnGaZCVyPxrOGG/AOQSwJA4/0CRGsZy1/+4kHjLGgQAH//ABbQzPBF6KZcyUMrVP/7EMQIgATQN1bsYYTAmgcqpZy8mSk+TZBSH2zkhwVA7Wd0ybnZ0eBX/rAgAAKqgCAjc/BWj5yhvakNLOEMB0iAgdWn6BTipJQlf/l0MJwUOBABVQAgJm3jgZ01B9nfn7JagAlHlUDh//sSxAuABNQ3UM1l5MibBupNjDyYUD+TRwE7IXfe/g7yvalhEB//wAFiCryDNHti2blKbDD0xwKJuW6A9h1HSt61+9JinIBv/6v9IA==";
audioSuccess.src = "data:audio/mp3;base64,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";
audioNotify.src = "data:audio/mp3;base64,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";

export default {
    name: 'i-notify',
    props: {
        timeout: { type: Number, default: 5500 }
    },
    methods: {
        hide(idx) {
            this.$set(this.notificationScope[idx], 'hide', true)
        }
    },
    mounted() {
        let self = this;
        let { timeout } = this;
        _i.bus.$on('notify', (_notification) => {
            let notification = _i.clone(_notification);
            notification.id = _.random(0, 9999999);
            if (_notification.type === 'success') {
                audioSuccess.play();
            } else if (_notification.type === 'error') {
                audioError.play()
            } else audioNotify.play();


            setTimeout(() => {
                this.$set(notification, 'hide', true)
            }, timeout);
            this.notificationScope.unshift(notification);
        });
    },
    data() {
        return {
            notificationScope: [
                /*{
                                title: "Пользователь уже авторизован",
                                text: "Вы уже авторизованны",
                                type: "warn",
                                hide: false
                            }, {
                                title: "Неправильный логин или пароль",
                                text: "Вы уже авторизованны",
                                type: "error",
                                hide: false
                            }, {
                                title: "Вы вышли из системы dasad sa dad asd asd asd sa",
                                text: "Пока пока!",
                                type: "success",
                                hide: false
                            }, {
                                title: "Вы вышли из системы",
                                text: "Do do sit magna do sed nostrud est ut exercitation dolor nulla proident dolore amet cillum exercitation ut irure non enim nostrud officia sint consectetur ex occaecat ut aliquip ut do ad ut proident id voluptate in fugiat esse.",
                                type: "info",
                                hide: false
                            }*/
            ]
        }
    }
}
</script>
<style lang="css" scoped>
.i-notify {
    position: fixed;
    z-index: 10002;
    right: 0;
    top: 0;
    color: white;
}

.title {
    font-size: 14px;
    font-weight: bold;
    color:white;
}

.text {
    font-size: 12px;
    margin-top: 2px;
    color:white;
}

.icon {
    float: left;
    font-size: 27px;
    margin-right: 8px;
    line-height: 0;
}

.content {
    float: left;
    max-width: 230px;
    min-width: 230px;
}

.close-button {
    position: absolute;
    margin-top: -6px;
    font-size: 10px;
    cursor: pointer;
    opacity: 0.2;
    right: 6px;
}

.notify:hover .close-button {
    opacity: 1;

}


.notify {
    background: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    margin: 2px;
    transition: 0.4s all ease, 4s max-height ease;
    cursor: default;
    opacity: 0;
    transform: translateX(290px);
    max-height: 0px;
    overflow: hidden;
}

.notify .container {
    padding: 8px;
    overflow: hidden;

}

.notify.shown {
    opacity: 1;
    transform: translateX(0);
    max-height: 1000px;
}

.notify:hover {
    background: rgba(0, 0, 0, 0.6);
}
</style>